import { useState, useEffect } from 'react';

export const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(window.matchMedia(query).matches);

  useEffect(() => {
    const media = window.matchMedia(query);
    if (media.matches !== matches) {
      setMatches(media.matches);
    }

    let timeoutId;
    const listener = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        setMatches(media.matches);
      }, 200); // تأخیر برای جلوگیری از تداخل با resize
    };

    media.addEventListener('change', listener);
    return () => {
      clearTimeout(timeoutId);
      media.removeEventListener('change', listener);
    };
  }, [query]);

  return matches;
};